import React from "react";
import styled from "styled-components";
import GenBtn from "../../components/GenBtn";
import * as Fa from "react-icons/fa";

const TablaPolizaEditar = ({ 
        datos, 
        eliminarLinea,
        diferenciaTotal
    }) => {
    
    return (
        <div>
            <TablaContainer>
                <Tabla>
                    <thead>
                        <tr>
                            <TableHeader>Cuenta</TableHeader>
                            <TableHeader>Debe</TableHeader>
                            <TableHeader>Haber</TableHeader>
                            <TableHeader>Acciones</TableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.map((poliza) => (
                            <TableRow key={poliza.id}>
                                <TableCell>{poliza.cuenta.cuenta} {poliza.cuenta.nombre}</TableCell>
                                <TableCell style={{ textAlign: 'right' }}>
                                    {parseFloat(poliza.debe) === 0 ? '' : 
                                     parseFloat(poliza.debe).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell style={{ textAlign: 'right' }}>
                                    {parseFloat(poliza.haber) === 0 ? '' : 
                                     parseFloat(poliza.haber).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell>
                                    <GenBtn
                                        textColor="hsl(0, 100%, 50%)"
                                        background="hsla(0, 100%, 50%, 0.2)"
                                        title="Eliminar"
                                        onPress={() => eliminarLinea(poliza.id, poliza.encabezado)}
                                    >
                                        <Fa.FaTrash />
                                    </GenBtn>
                                </TableCell>
                            </TableRow>
                        ))}
                        {datos.length > 0 && (
                            <TableRow style={{ borderTop: '2px solid #ccc', fontWeight: 'bold' }}>
                                <TableCell style={{ fontWeight: 'bold' }}>TOTAL</TableCell>
                                <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                    {datos.reduce((sum, linea) => sum + parseFloat(linea.debe), 0)
                                    .toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                    {datos.reduce((sum, linea) => sum + parseFloat(linea.haber), 0)
                                    .toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        )}
                        {datos.length === 0 && (
                            <TableRow>
                                <TableCell colSpan="4" style={{ textAlign: "center" }}>
                                    No hay líneas agregadas
                                </TableCell>
                            </TableRow>
                        )}
                    </tbody>
                </Tabla>

                <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
                    <div>
                        {diferenciaTotal !== 0 && (
                        <span style={{ color: "white" }}>
                            Diferencia: {Math.abs(diferenciaTotal).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                        )}
                    </div>
                </div>
            </TablaContainer>
            <br/>
        </div>
    );
};


const TablaContainer = styled.div`
    margin-top: 20px;
    width: 100%;
    overflow-x: auto;
`;

const Tabla = styled.table`
    width: 100%;
    border-collapse: collapse;
    background-color: #333;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    color: #eee;
`;

const TableHeader = styled.th`
    padding: 12px 15px;
    text-align: left;
    background-color: #404040;
    border-bottom: 1px solid #555;
    font-weight: bold;
    color: #fff;
`;

const TableRow = styled.tr`
    &:nth-child(even) {
        background-color: #3a3a3a;
    }
    
    &.totals-row {
        background-color: #2d2d2d;
        color: #fff;
        font-weight: bold;
    }
`;

const TableCell = styled.td`
    padding: 12px 15px;
    border-bottom: 1px solid #555;
`;


export default TablaPolizaEditar;
